export class DisputeStatus {
    disputeStatusCode: string;
    disputeStatusDesc: string;
}

export class DisputeCategory {
    disputeCategoryCode: string;
    disputeCategoryDesc: string;
}

export class DisputeCategoryComments {
    disputeCategoryCode: string;
    categoryCode: string;
    categoryDesc: string;
}
